// extracted by mini-css-extract-plugin
export default {"list":"language_list__3HoOt","inactive":"language_inactive__OKzjl","active":"language_active__QSHOC"};